import _get from 'lodash/get';

import {
  FETCH_OPERATORS,
  DEACTIVATE_FROM_APP,
  RATE_LESS_THAN_MKT_RATE,
  FO_RESPONSE_CONSIGNMENT,
  FO_RESPONSE_QUOTATION,
  FO_RESPONSE_VEHICLE,
  FETCH_FEEDBACK_CONFIG,
  FETCH_FEEDBACK_VALUES,
  SET_RESPONSE_ID,
  FETCH_OPERATOR_INFO,
  SET_SOURCE,
  CLEAR_OPERATOR_LIST,
  SEND_TOKEN_LINK,
  RETRY_TOKEN_LINK,
  CONTROL_BOOKING_AUTOMATION,
  SEND_NOTIF_LINK,
} from './action';
import { REQUEST, SUCCESS, FAILURE } from 'utils/actionGenerator';

const defaultState = {
  tokenLinkSent: false,
  NotifLinkSent: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_OPERATORS[SUCCESS]:
      return { ...state, ...action.response.data };
    case CLEAR_OPERATOR_LIST:
      return { ...state, operatorDetails: [] };
    case DEACTIVATE_FROM_APP[SUCCESS]: {
      return {
        ...state,
        demandDetails: {
          ...state.demandDetails,
          isActiveOnApp: action.activate,
        },
        activate: action.activate,
      };
    }
    case RATE_LESS_THAN_MKT_RATE[SUCCESS]:
      return {
        ...state,
        demandDetails: {
          ...state.demandDetails,
          lessThanMarketRate: action.lessThanMinimumMarketRate,
        },
      };
    case RATE_LESS_THAN_MKT_RATE[FAILURE]:
      return {
        ...state,
        demandDetails: {
          ...state.demandDetails,
          lessThanMarketRate: false,
        },
      };
    case FO_RESPONSE_CONSIGNMENT[SUCCESS]:
      return {
        ...state,
        foResponse: { count: action.response.data.count || 0, list: action.response.data.consignments || [] },
      };
    case FO_RESPONSE_CONSIGNMENT[FAILURE]:
      return { ...state, foResponse: { count: 0, list: [] } };
    case FO_RESPONSE_VEHICLE[SUCCESS]:
      return {
        ...state,
        foResponse: { count: action.response.data.count || 0, list: action.response.data.vehicles || [] },
      };
    case FO_RESPONSE_VEHICLE[FAILURE]:
      return { ...state, foResponse: { count: 0, list: [] } };
    case FO_RESPONSE_QUOTATION[SUCCESS]:
      return {
        ...state,
        foResponse: { count: action.response.data.count || 0, list: action.response.data.consignments || [] },
      };
    case FO_RESPONSE_QUOTATION[FAILURE]:
      return { ...state, foResponse: { count: 0, list: [] } };
    case FETCH_FEEDBACK_CONFIG[SUCCESS]:
      return {
        ...state,
        feedback: {
          ...state.feedback,
          config: action.response.data,
        },
      };
    case FETCH_FEEDBACK_VALUES[SUCCESS]:
      return { ...state, feedback: { ...state.feedback, selectedValues: action.response.data } };
    case FETCH_OPERATOR_INFO[SUCCESS]:
      return { ...state, operatorInfo: action.response.data };

    case SEND_TOKEN_LINK[SUCCESS]:
      return { ...state, tokenLinkStatus: action.response.data, tokenLinkSent: true };
    case SEND_TOKEN_LINK[FAILURE]:
      return { ...state, tokenLinkSent: state.tokenLinkSent === true ? false : true };
    case SEND_NOTIF_LINK[SUCCESS]:
      return { ...state, notifLinkStatus: action.response.data, NotifLinkSent: true };
    case SEND_NOTIF_LINK[FAILURE]:
      return { ...state, NotifLinkSent: state.NotifLinkSent === true ? false : true };
    case RETRY_TOKEN_LINK[SUCCESS]:
      return { ...state, tokenLinkSent: true };
    case RETRY_TOKEN_LINK[FAILURE]:
      return { ...state, tokenLinkSent: state.tokenLinkSent === true ? false : true };
    case SET_RESPONSE_ID:
      return {
        ...state,
        editFO: { ...action.payload },
        foResponse: {},
        feedback: {},
      };
    case SET_SOURCE:
      return {
        ...state,
        source: action.payload,
      };
    case CONTROL_BOOKING_AUTOMATION[REQUEST]:
      return {
        ...state,
        bookingAutomationStopped: false,
      };
    case CONTROL_BOOKING_AUTOMATION[SUCCESS]:
      return {
        ...state,
        bookingAutomationStopped: true,
      };
    case CONTROL_BOOKING_AUTOMATION[FAILURE]:
      return {
        ...state,
        bookingAutomationStopped: false,
      };
    default:
      return state;
  }
}

export const getOverview = (state) => _get(state, 'placement.opSearch.demandDetails', {});

export const getOperatorsList = (state) => _get(state, 'placement.opSearch.operatorDetails', []);

export const isActivatedOnApp = (state) => _get(state, 'placement.opSearch.activate', null);

export const getFoResponseData = (state) => _get(state, 'placement.opSearch.foResponse', {});

export const getFeedbackConfig = (state) => _get(state, 'placement.opSearch.feedback.config', {});

export const getFeedbackSelectedValues = (state) => _get(state, 'placement.opSearch.feedback.selectedValues', {});

export const getCurrentResponse = (state) => _get(state, 'placement.opSearch.editFO', {});

export const getOperatorInfo = (state) => _get(state, 'placement.opSearch.operatorInfo', {});

export const getSource = (state) => _get(state, 'placement.opSearch.source', 'GPS_V2');

export const getTokenLinkSent = (state) => _get(state, 'placement.opSearch.tokenLinkSent');
export const getNotifLinkSent = (state) => _get(state, 'placement.opSearch.NotifLinkSent');

export const getbookingAutomationStoppedStatus = (state) => _get(state, 'palcement.opSearch.bookingAutomationStopped');
